/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateOnboardingDraftResponse, UpdateOnboardingProfileApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateOnboardingProfile: build.mutation<UpdateOnboardingDraftResponse, UpdateOnboardingProfileApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/v1/onboarding/profile`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateOnboardingProfileApi };
export const { useUpdateOnboardingProfileMutation } = injectedRtkApi;
